import React, { useEffect, useRef } from 'react';

import { handleMenuKeyDown } from '../../lib/menuKeyboard';

// Mounts with the open panel. Focus lands on the menu itself — no item is highlighted until the
// first arrow key. A fixed panel stays hidden until positioned, and hidden elements can't take focus.
const PopoverMenu = ({ isReady, triggerRef, children }) => {
  const menuRef = useRef(null);
  const hasFocusedRef = useRef(false);

  useEffect(() => {
    if (!isReady || hasFocusedRef.current) return;
    hasFocusedRef.current = true;
    menuRef.current?.focus({ preventScroll: true });
  }, [isReady]);

  return (
    // `gap: inherit` keeps the panel's spacing, including `panelClassName` gap overrides.
    <div
      ref={menuRef}
      role="menu"
      aria-labelledby={triggerRef?.current?.id || undefined}
      tabIndex={-1}
      className="flex flex-col outline-none [gap:inherit]"
      onKeyDown={handleMenuKeyDown}>
      {children}
    </div>
  );
};

export default PopoverMenu;
